import { styled } from "styled-components";

export const Container = styled.input(({ theme }) => {
  return {
    height: theme.sizes.md,
    boxSizing: "border-box",
    border: "1px solid rgba(115,115,118,0.3)",
    borderRadius: theme.radii[1],
    backgroundColor: theme.colors.white,
    boxShadow: `0 1px 12px ${theme.shadows[2]}`,
    transition: "border-color 250ms",
    padding: `0 ${theme.space[4]}`,
    color: theme.colors.black,

    "&:focus": {
      border: "1px solid rgba(115,115,118,0.5)",
      outline: 0,
    },

    "&::placeholder": {
      color: theme.colors.grayDark,
    },

    // Size variants
    '&[data-size="sm"]': {
      height: theme.sizes.sm,
      fontSize: theme.fontSizes["2"],
      lineHeight: theme.lineHeights["1"],
      padding: `0 ${theme.space["3"]}`,
    },
    '&[data-size="md"]': {
      height: theme.sizes.md,
      fontSize: theme.fontSizes["2"],
      lineHeight: theme.lineHeights["2"],
    },
    '&[data-size="lg"]': {
      height: theme.sizes.lg,
      fontSize: theme.fontSizes["2"],
      lineHeight: theme.lineHeights["2"],
    },
    '&[data-size="xl"]': {
      height: theme.sizes.xl,
      fontSize: theme.fontSizes["3"],
      lineHeight: theme.lineHeights["3"],
    },
  };
});
